export default "__VITE_ASSET__DRRZemJ2__"